import React, { useState, useEffect, useRef } from 'react';
import styles from './announcements.module.scss';
import { Button, Carousel, Col, Row } from 'react-bootstrap';
import { api } from '../../Utils/API';
import { GET_ANNOUNCEMENTS } from '../../Utils/GlobalConstants';
import EmptyAnnouncement from '../../Assets/Images/Illustrations/EmptyAnnouncement.svg';

const Announcement = ({ Logout }) => {
    const [announcementData, setAnnouncementData] = useState([]);
    const [announcementDataEmpty, setAnnouncementDataEmpty] = useState(false);
    const [expandedAnnouncement, setExpandedAnnouncement] = useState(null);
    const [contentHeights, setContentHeights] = useState({});
    const contentRefs = useRef({});
    
    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };
    
    // Function to get Announcement Data
    async function GetAnnouncements() {
        await api.get(GET_ANNOUNCEMENTS, config)
            .then(resp => {
                if(resp.status==200){
                    setAnnouncementDataEmpty(false);
                    setAnnouncementData(resp.data);
                    
                    if(resp.data.length === 0){
                        setAnnouncementDataEmpty(true);
                    }
                }
                else{
                    setAnnouncementDataEmpty(true);
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                   Logout();
                }
                else {
                    // console.log(error);
                }
            });
    };
    
    useEffect(() => {
        GetAnnouncements();
    }, []);

    // Check content heights after rendering
    useEffect(() => {
        if (announcementData.length > 0) {
            setTimeout(() => {
                const heights = {};
                Object.keys(contentRefs.current).forEach(key => {
                    if (contentRefs.current[key]) {
                        heights[key] = contentRefs.current[key].scrollHeight;
                    }
                });
                setContentHeights(heights);
            }, 100);
        }
    }, [announcementData, expandedAnnouncement]);
    
    // to show carousel controls & indicators
    const showCarouselControls = announcementData.length > 1;

    // Check if the content contains an span
    const hasSpan = (content) => {
        return content && content.includes('<span');
    };

    // Check if the content has images
    const hasImage = (content) => {
        return content && content.includes('<img');
    };

    // Check if the content has not image and not span
    const isContentOnly = (content) => {
        return !hasSpan(content) && !hasImage(content);
    };

    // Check if content is truncated and needing "Read more" button
    const isContentTruncated = (content) => {
        const textLengthBasedTruncation = content.length > 450;
        return textLengthBasedTruncation;
    };

    const toggleExpand = (index) => {
        if (expandedAnnouncement === index) {
            setExpandedAnnouncement(null);
        } else {
            setExpandedAnnouncement(index);
        }
    };

    const setContentRef = (index, element) => {
        contentRefs.current[`content-${index}`] = element;
    };

    return (
        <div className={`${styles['announcement-wrapper']}`}>
            <div className={`${styles['announcement-body-main']}`}>
                <h2 className="mb-3" >Announcements {!announcementDataEmpty && `(${announcementData.length})`}</h2>
                <div className={`${styles['carousel-container']}`} data-testid="announcement-carousel-container">
                    {!announcementDataEmpty && announcementData && announcementData.length > 0 && 
                        <Carousel
                            className={`${styles['carousel-announcement']} ${showCarouselControls ? styles['with-controls'] : ''}`}
                            touch={showCarouselControls}
                            indicators={showCarouselControls}
                            interval={null}
                            controls={showCarouselControls}
                        >
                            {announcementData && announcementData.length > 0 && announcementData.map((data, index) => {
                                const isExpanded = expandedAnnouncement === index;
                                const isSpanAnnouncement = hasSpan(data.content);
                                const isImageAnnouncement = hasImage(data.content);
                                const isContentOnlyAnnouncement = isContentOnly(data.content);
                                const needsReadMore = isContentTruncated(data.content);
                                
                                return(
                                    <Carousel.Item key={index}>
                                        <div className={`${styles['announcements-body']} ${isExpanded ? styles['expanded'] : ''}`}>
                                            {isImageAnnouncement && !isSpanAnnouncement && (
                                                <>
                                                    {data.content && (
                                                    <div className={`${styles['announcement-content']}`}>
                                                        <div 
                                                            className={`${styles['content-container']} ${isExpanded ? styles['expanded'] : ''} ${needsReadMore && !isExpanded ? styles['needs-read-more'] : ''}`}
                                                            ref={(el) => setContentRef(index, el)}
                                                        >
                                                            <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                                                        </div>
                                                        
                                                        {needsReadMore && (
                                                            <div className={`py-2 ${styles['text-right']} ${styles['enrollment-btn-col']}`}>
                                                                <Button
                                                                    variant="light"
                                                                    className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        toggleExpand(index);
                                                                    }}
                                                                >
                                                                    {isExpanded ? 'Read less' : 'Read more'}
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    )}
                                                    
                                                    <Row className={`mt-3 ${styles['announcement-info-row']}`}>
                                                        {data.title && (
                                                        <Col xs={12} md={7} lg={8} className={`${styles['announcement-title-col']}`}>
                                                            <div className={`${styles['announcement-title-wrapper']}`}>
                                                                {data.title}
                                                            </div>
                                                        </Col>
                                                        )}
                                                        {data.link && (
                                                            <Col xs={12} md={5} lg={4} className={`${styles['enrollment-btn-col']}`}>
                                                                <Button
                                                                    variant="light"
                                                                    className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                    onClick={() => window.open(data.link, '_blank')}
                                                                >{data?.buttonLabel ? data.buttonLabel : "Enroll Now"}
                                                                </Button>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </>
                                            )}
                                            
                                            {isSpanAnnouncement && (
                                                <>
                                                {data.title && (
                                                    <div className={`${styles['announcement-header']}`}>
                                                        <h1 className={`${styles['announcement-title']}`}>{data.title}</h1>
                                                    </div>
                                                )}
                                                    {data.content && (
                                                    <div className={`${styles['announcement-content']}`}>
                                                        <div 
                                                            className={`${styles['content-container']} ${isExpanded ? styles['expanded'] : ''} ${needsReadMore && !isExpanded ? styles['needs-read-more'] : ''}`}
                                                            ref={(el) => setContentRef(index, el)}
                                                        >
                                                            <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                                                        </div>
                                                        
                                                        {needsReadMore && (
                                                            <div className={`py-2 ${styles['text-right']} ${styles['enrollment-btn-col']}`}>
                                                                <Button
                                                                    variant="light"
                                                                    className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        toggleExpand(index);
                                                                    }}
                                                                >
                                                                    {isExpanded ? 'Read less' : 'Read more'}
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    )}
                                                </>
                                            )}
                                            
                                            {/* For content-only announcements */}
                                            {isContentOnlyAnnouncement && (
                                                <div className={`${styles['announcement-content']} ${styles['content-only']}`}>
                                                    <div 
                                                        className={`${styles['content-container']} ${isExpanded ? styles['expanded'] : ''} ${needsReadMore && !isExpanded ? styles['needs-read-more'] : ''}`}
                                                        ref={(el) => setContentRef(index, el)}
                                                    >
                                                        <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                                                    </div>
                                                    
                                                    {needsReadMore && (
                                                        <div className={`py-2 ${styles['text-right']} ${styles['enrollment-btn-col']}`}>
                                                            <Button
                                                                variant="light"
                                                                className={`btn-border-light ${styles['enroll-now-btn']}`}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    toggleExpand(index);
                                                                }}
                                                            >
                                                                {isExpanded ? 'Read less' : 'Read more'}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Carousel.Item>
                                );
                            })}
                        </Carousel>
                    }
                     {/* For no announcements screen */}
                    {announcementDataEmpty && 
                        <div className={`${styles['announcements-body']} ${styles['empty-announcements']}`}>
                            <div className={`${styles['empty-announcement-content']}`}>
                                <img src={EmptyAnnouncement} className={`${styles['empty-announcement-svg']}`} alt="No Announcements" />
                                <h4>No Announcements</h4>
                                <p>We will display any new announcements here</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default Announcement;